import { buildProps } from '@zoryn/utils'
import { componentSizes } from '@zoryn/constants'

import type { ExtractPropTypes, ExtractPublicPropTypes } from 'vue'
import type Jumper from './jumper.vue'

export const paginationJumperProps = buildProps({
  size: {
    type: String,
    values: componentSizes,
  },
} as const)

export type PaginationJumperProps = ExtractPropTypes<
  typeof paginationJumperProps
>
export type PaginationJumperPropsPublic = ExtractPublicPropTypes<
  typeof paginationJumperProps
>

export type PaginationJumperInstance = InstanceType<typeof Jumper> & unknown
